import React from 'react';
import RulesSettings from '../components/settings/RulesSettings';

export default function Rules() {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-slate-900">Automations</h1>
        <p className="mt-1 text-sm text-slate-500">
          Configure how patients are prioritized and how outreach is delivered.
        </p>
      </div>

      {/* Rules Content */}
      <RulesSettings />
    </div>
  );
}
